module.exports = __webpack_public_path__ + "img/apply4.65107dd0.png";